interface TrendSensitivityIconBarGraphProps {
    size?: number;
    className?: string;
  }
  
  export default function TrendSensitivityIconBarGraph({ 
    size = 128, 
    className = "" 
  }: TrendSensitivityIconBarGraphProps) {
    return (
      <svg
        width={size}
        height={size * 0.7}
        viewBox="0 0 110 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        {/* Background grid - very light */}
        <g opacity="0.1">
          {/* Horizontal lines */}
          <line x1="5" y1="15" x2="105" y2="15" stroke="currentColor" strokeWidth="0.5" />
          <line x1="5" y1="30" x2="105" y2="30" stroke="currentColor" strokeWidth="0.5" />
          <line x1="5" y1="45" x2="105" y2="45" stroke="currentColor" strokeWidth="0.5" />
          <line x1="5" y1="60" x2="105" y2="60" stroke="currentColor" strokeWidth="0.5" />
          
          {/* Vertical lines */}
          <line x1="20" y1="5" x2="20" y2="65" stroke="currentColor" strokeWidth="0.5" />
          <line x1="35" y1="5" x2="35" y2="65" stroke="currentColor" strokeWidth="0.5" />
          <line x1="50" y1="5" x2="50" y2="65" stroke="currentColor" strokeWidth="0.5" />
          <line x1="65" y1="5" x2="65" y2="65" stroke="currentColor" strokeWidth="0.5" />
          <line x1="80" y1="5" x2="80" y2="65" stroke="currentColor" strokeWidth="0.5" />
          <line x1="95" y1="5" x2="95" y2="65" stroke="currentColor" strokeWidth="0.5" />
        </g>
        
        {/* Border box */}
        <rect
          x="5"
          y="5"
          width="100"
          height="60"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          rx="2"
        />
        
        {/* Vertical bars from bottom to each point - all same width */}
        
        {/* Bar 1 - to peak 1 (y=35) */}
        <rect
          x="19"
          y="35"
          width="8"
          height="30"
          rx="1"
          fill="currentColor"
          opacity="0.15"
        />
        
        {/* Bar 2 - to valley 1 (y=45) */}
        <rect
          x="31"
          y="45"
          width="8"
          height="20"
          rx="1"
          fill="currentColor"
          opacity="0.15"
        />
        
        {/* Bar 3 - to peak 2 (y=25) */}
        <rect
          x="44"
          y="25"
          width="8"
          height="40"
          rx="1"
          fill="currentColor"
          opacity="0.15"
        />
        
        {/* Bar 4 - to valley 2 (y=40) */}
        <rect
          x="56"
          y="40"
          width="8"
          height="25"
          rx="1"
          fill="currentColor"
          opacity="0.15"
        />
        
        {/* Bar 5 - to peak 3 (y=15) */}
        <rect
          x="71"
          y="15"
          width="8"
          height="50"
          rx="1"
          fill="currentColor"
          opacity="0.15"
        />
        
        {/* Bar 6 - to end (y=10) */}
        <rect
          x="91"
          y="10"
          width="8"
          height="55"
          rx="1"
          fill="currentColor"
          opacity="0.15"
        />
        
        {/* Pattern indicators at top of each bar */}
        
        {/* Peak 1 - Filled small bar */}
        <rect
          x="19"
          y="32"
          width="8"
          height="3"
          rx="1.5"
          fill="currentColor"
        />
        
        {/* Valley 1 - Empty circle */}
        <circle
          cx="35"
          cy="45"
          r="2.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        
        {/* Peak 2 - Empty small bar */}
        <rect
          x="44"
          y="22"
          width="8"
          height="3"
          rx="1.5"
          fill="none"
          stroke="currentColor"
          strokeWidth="1"
        />
        
        {/* Valley 2 - Grey big bar */}
        <rect
          x="52"
          y="37.5"
          width="16"
          height="5"
          rx="2.5"
          fill="currentColor"
          opacity="0.4"
        />
        
        {/* Peak 3 - Filled circle */}
        <circle
          cx="75"
          cy="15"
          r="2.5"
          fill="currentColor"
        />
        
        {/* End point - Filled bigger bar */}
        <rect
          x="87"
          y="7.5"
          width="16"
          height="5"
          rx="2.5"
          fill="currentColor"
        />
      </svg>
    );
  }
  